import { feedbackReducer, initialFeedbackState } from './FeedbackState';
import { initialStyleOptions } from './StyleOptions';
export const initialWebChatState = {
    styleOptions: initialStyleOptions,
    feedback: initialFeedbackState
};
export const bffWebChatReducer = (state, action) => {
    switch (action.type) {
        case 'setConfig':
            return Object.assign(Object.assign({}, state), { config: action.config });
        case 'feedbackOpen':
        case 'feedbackClose':
            return Object.assign(Object.assign({}, state), { feedback: feedbackReducer(state.feedback, action) });
    }
};
//# sourceMappingURL=BFFWebChatState.js.map